import React from 'react'
import './style/index.css'
import { Link } from 'react-router-dom'
export default function Statement() {
  return (
    <div className="sment">
      <div className="s_left">
        <div className="mz sment_active">免责声明</div>
        <Link to={'/complaint'}>
          <div className="ts">投诉处理</div>
        </Link>
      </div>
      <div className="statement">
        <div class="wrap_r">
          <p>
            &nbsp; &nbsp;
            用户在本网站下载软件视为已经阅读并同意本声明内容，空特下载站上的所有软件和资料均为软件作者提供发布，仅供个人学习和研究使用，不得用于任何商业用途。如有侵犯您商标权、著作权或其他合法权利的，请联系我们并按照网站公告中的投诉流程规定提供相关证明材料，本站将在第一时间对此进行核实并处理。
          </p>
          <p>
            &nbsp; &nbsp;
            访问空特下载站的用户已经充分理解，除非另有说明，空特下载站所提供下载的软件和程序代码的版权归该软件和程序代码的合法拥有者所有，请用户在下载使用前必须详细阅读并遵守软件作者的“使用许可协议”。
          </p>
          <p>
            &nbsp; &nbsp;
            空特下载站保证站内提供的所有可下载资源(软件等等)都是按照“原样”提供，并未对其做过任何改动。但空特下载站不保证本站提供的下载资源的准确性、安全性和完整性。同时，空特下载站也不承担用户因使用这些下载资源对自己和他人造成任何形式的损失或伤害。
          </p>
          <p>
            &nbsp; &nbsp;
            空特下载站网页内的资料提供者拥有该网页上资料的版权，未经空特下载站的明确许可，任何人不得非法复制，不得盗链本站下载资源。空特下载站对其自行开发的或者和他人共同开发的所有内容，包括网站设计、布局结构、服务等拥有全部知识产权，未经空特下载站的明确许可，任何人不得作全部或部分复制或仿造。
          </p>
          <p>
            &nbsp; &nbsp;
            凡由于使用或无法使用本网站，或任何执行失败、错误、遗漏、中断、删除、缺陷、操作或传送的延误、计算机病毒、通信线路失灵、线上通信的拦截、软件或硬件问题(包括但不限于丢失数据或兼容性问题)、偷窃、网站的破坏或改变所引起的，无论是因使用本网站或向本网站上载或从本网站下载或出版数据、文字、图像或其他资料或资料而直接或间接造成的违约、侵权行为、疏忽或任何其他诉因所引起的任何种类损害或伤害(包括但不限于意外损害、间接损害、利润的损失、或者因失去数据或业务被中断所造成的损害)，且无论本网站是否已被告知此种损害的可能性，本网站或在本网站上提及的任何第三方在法律允许的范围内不应承担任何责任。
          </p>
        </div>
      </div>
    </div>
  )
}
